<template>
    <transition name="modal custom-modal">
        <div class="modal-mask modal-lg">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <button type="button" class="close" @click="$emit('close')">
                            <span aria-hidden="true">×</span><span class="sr-only">Close</span>
                        </button>
                        <h3 style="width: initial;"><i class="fa fa-lg fa-info-circle"></i> Request <small>{{ request.id }}</small></h3>
                    </div>
                    <div class="modal-body pre-scrollable" v-bind:style="{'max-height': bodyHeight + 'px'}">
                        <div class="lead-detail">
                          <div class="panel-body">

                            <div class="col-xs-12 bg-dark lead-data">
                              <h4>Metadata</h4>
                              <div class="col-xs-12">
                                <ul class="contact-info">
                                  <li><i class="fa fa-lg fa-clock-o"></i> <b>{{ request.created | formatTimestamp }}</b></li>
                                  <li>Customer: <b>{{ request.campaign.customer }}</b></li>
                                  <li>Campaign: <b>{{ request.campaign.name }}</b></li>
                                  <li>Status: <b>{{ request.status | uppercase }}</b></li>
                                  <li v-if="request.billing_status">Billing Status: <b>{{ request.billing_status | uppercase }}</b></li>
                                  <li>Conversion: <i v-if="request.is_sale" class="fa fa-lg fa-check-square-o"></i><i v-else class="fa fa-lg fa-square-o"></i></li>
                                </ul>
                              </div>
                            </div>
                            <div v-if="request.errors.length" class="col-xs-12 bg-dark lead-data">
                              <h4>Errors</h4>
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th>Code</th>
                                    <th>Field</th>
                                    <th>Message</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="e in request.errors">
                                    <td>{{ e.code }}</td>
                                    <td>{{ e.field | ifNull(e.fields) | join(', ') }}</td>
                                    <td>{{ e.message }}</td>
                                  </tr>

                                </tbody>
                              </table>
                            </div>

                            <div class="col-xs-12 bg-dark lead-data">
                              <h4>Data</h4>
                              <div class="col-xs-12 fields-list-wrapper">
                                <table class="table">
                                  <thead>
                                    <tr>
                                      <th>Field</th><th>Value</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="v, k in request.lead_fields"><td>{{ k }}</td><td><b>{{ v }}</b></td></tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>


<script>

export default {
  name: 'RequestDataModal',
  props: {
    requestData: {
      type: Object
    }
  },
  data: function () {
    return {
      request: this.requestData
    };
  },
computed: {
   bodyHeight () {
     return $(window).height() - 200;
   }
  },

  methods: {

  }
}
</script>
<style>
  .panel-body div.lead-data + div {
  margin-top: 30px;
  }

 .modal-header h3 {
  text-transform: unset!important;
  }

  .lead-detail .panel-body h4 button {
  right: 20px;
  top: 10px;
  position: absolute;
  }

  .lead-detail .panel-body > div {
  padding: 10px 20px;
  }

  .lead-detail .panel-body > div.fields-list-wrapper {
  padding: 0px;
  }

  .lead-detail h4 {
  padding-bottom: 10px;
  }

  .bg-dark {
  background-color: #f7f7f7;
  border-radius: 4px 4px;
  }
  ul.contact-info li i {
  color: #aaa;
  }
  ul.contact-info > li:not(:first-child)::before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  border: 1px solid #dadada;
  width: .75em;
  margin-left: 20px;
  margin-right: 20px;
  }
  ul.contact-info li {
  display: inline-block;
  }

  .score-model-name {
  font-weight: 700;
  }
  .score-model-date {
  font-weight: 700;
  }
  .score-value {
  font-weight: 700;
  font-size: 2.75em;
  color: #ff4d50;
  text-align: right;
  padding-left: 30px;
  min-width: 50%;
  }

  .fields-list-wrapper > div {
  padding: 10px 20px;
  }

  .fields-list-wrapper > div.lead-fields {
  margin-right: 10px;
  }

  .fields-list-wrapper div.crm-fields {
  margin-left: 10px;
  }

  .lead-detail table {
  border-radius: 4px;
  }

  .lead-detail .table > tbody > tr > td {
  padding: 10px 10px;
  }

  .lead-detail th {
  background-color: initial;
  color: initial;
  }

  .service-title {
    text-transform: uppercase;
  }

  .lead-data table {
    overflow-x: auto;
  }

</style>



// WEBPACK FOOTER //
// RequestDataModal.vue?8fcb4d98